<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg8.jpg" alt="" />
    <div class="activity-content">
      <div>充<span>{{materialParamsDTO.materialParamsDetailDTOList[0].rechargeMoney}}</span>
      <em v-if="materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMember==4">包年</em>
      <em v-if="materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMember==3">包半年</em>
      <em v-if="materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMember==2">包季</em>
      <em v-if="materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMember==1">包月</em>
      <em v-if="materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMember==0">包周</em>
      </div>
      <p>畅享所有图书</p>
      <button v-if="status==2" @click="goTopay">立即领取</button>
    
      <button v-if="status==1" class="default-btn">活动尚未开始</button>
      <button v-if="status==0" class="default-btn">活动已下线</button>
      <button v-if="status==3" class="default-btn">活动已结束</button>
       <div class="activity-tip">
        <p>活动规则</p>
           <p>1、活动时间：即日起至<span v-if="endTime">{{endTime}}</span></p>
      <p>2、本次活动
        <span v-if="purchaseLimitDTO.purchaseLimitType==2">参与次数不限</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==1">每天仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==0">每人仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
      </p>
        <p>3、此充值为书币充值，一经充值不支持退款</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:['status','materialParamsDTO','endTime','purchaseLimitDTO'],
  data() {
    return {
    };
  },
  watch:{
    materialParamsDTO:{
        handler: function (val) {
         console.log(val)
        },
        deep: true
    },
    purchaseLimitDTO:{
       handler: function (val) {
         console.log(val)
        },
        deep: true
    }
  },
  methods:{
    goTopay(){
      this.$emit('payActivity',this.materialParamsDTO.materialParamsDetailDTOList[0])
    }
  }
};
</script>
<style scoped>
em{
  font-style: initial;
}
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(217px + env(safe-area-inset-top));
}
.activity-content > div {
  font-size: 30px;
  color: #333333;
  text-align: center;

  font-weight: bold;
  line-height: 42px;
}
.activity-content > div > span {
  color: #e31a0b;
}
.activity-content > p {
  text-align: center;
color: #E31A0B;
  font-size: 20px;
  margin-top: 4px;
  margin-bottom:14px;
}
.activity-content > button {
  height: 43px;
  line-height: 43px;
background: #22130C;
box-shadow: 0 2px 4px 0 rgba(110,110,110,0.50);
border-radius: 100px;
  font-size: 20px;
color: #EDD9B8;
  text-align: center;
  width: 186px;
  margin: 0 auto;
  display: block;
  border: none;
}
.activity-content > button.default-btn {
  background: #cfcfcf;
  box-shadow: 0 2px 4px 0 rgba(110, 110, 110, 0.5);
  border-radius: 100px;
  font-size: 20px;
  color: #636363;
}
.activity-content > .activity-tip {
  margin:0 auto;
  margin-top: 8px;
  text-align: left;
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 14px;
}
.activity-tip p {
  font-size: 12px;
color: #22130C;
white-space: nowrap;
  line-height: 17px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modeleight.vue